export interface IUserGraph {
    id: string;
    displayName: string;
    mail: string;
}
